import { STASH, MY_ACCOUNT_SETTINGS } from '../constants';

// stashLinkEvent(action) (src/utils/analytics.ts)
// Shared by security-alert.tsx, home-depot-credit-cards.tsx,
// security-sign-in-card.tsx, and upgrade-to-pro.tsx link clicks.
// Caller passes the fully-formatted action string, e.g.
// "profile page: link: security and password page" or
// "account dashboard: home depot credit cards: view card offers".
export const stashLinkEvent = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('stash-link.event', ({ output }) => {
    const action = output?.action || '';

    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: action
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
